export const HOTKEYS = {
  closeEdit: 'Escape',
  collapseSidebar: 'b',
  commitEdit: 'Enter',
  developmentSection: 'd',
  down: 'ArrowDown',
  focusSearch: '/',
  navigateBackToRepo: 'Escape',
  navigateToNextIssue: 'k',
  navigateToPrevIssue: 'j',
  navigateToSelectedIssue: 'Enter',
  up: 'ArrowUp',
}
